function getRecentlyViewedProducts() {
  let viewedProducts = [];
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith('recently_viewed_products'))
    ?.split('=')[1];
  if (cookie) {
    viewedProducts = JSON.parse(cookie);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct(productHandle) {
  const viewedProducts = getRecentlyViewedProducts();
  const index = viewedProducts.indexOf(productHandle);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productHandle);
  viewedProducts.slice(0, 12);
  document.cookie = `recently_viewed_products=${JSON.stringify(
    viewedProducts,
  )};max-age=${60 * 60 * 24 * 30};path=/`;
}
